"use client";

import { useCallback, useRef } from "react";

type VideoId = number | string | null | undefined;

function getApiBaseUrl() {
	return process.env.NEXT_PUBLIC_BASE_API_URL ?? process.env.NEXT_PUBLIC_BASE_API_URL ?? "";
}

export default function useVideoView(videoId: VideoId) {
	const hasSentRef = useRef(false);

	const sendView = useCallback(() => {
		if (hasSentRef.current) return;
		if (videoId === null || videoId === undefined || videoId === "") return;

		const apiBaseUrl = getApiBaseUrl().replace(/\/+$/, "");
		if (!apiBaseUrl) return;

		hasSentRef.current = true;
		const token = localStorage.getItem("accessToken");
		const config: RequestInit = {
			method: "POST",
			credentials: "include",
			headers: {},
		};
		if (token) {
			config.headers["Authorization"] = `Bearer ${token}`;
		}

		void fetch(`${apiBaseUrl}/api/v1/video/${videoId}/view`, config).catch(() => {
			// silent fail
		});
	}, [videoId]);

	return { sendView };
}
